var React = require('react');

function LinkedinInBrands (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.7588 56.8763H0.941518V18.9046H12.7588V56.8763ZM6.84382 13.7249C3.06502 13.7249 0 10.6019 0 6.83137C2.7047e-08 5.02026 0.721043 3.28332 2.00451 2.00267C3.28797 0.722025 5.02872 0.00256348 6.84382 0.00256348C8.65891 0.00256348 10.3997 0.722025 11.6831 2.00267C12.9666 3.28332 13.6876 5.02026 13.6876 6.83137C13.6876 10.6019 10.6213 13.7249 6.84382 13.7249ZM56.9873 56.8763H45.1954V38.3919C45.1954 33.9866 45.1063 28.3372 39.0514 28.3372C32.9073 28.3372 31.9658 33.1234 31.9658 38.0745V56.8763H20.1612V18.9046H31.495V24.0843H31.6604C33.2381 21.1009 37.092 17.9525 42.8416 17.9525C54.8014 17.9525 57 25.8109 57 36.0179V56.8763H56.9873Z","fill":"white"}));
}

LinkedinInBrands.defaultProps = {"width":"57","height":"65","viewBox":"0 0 57 65","fill":"none"};

module.exports = LinkedinInBrands;

LinkedinInBrands.default = LinkedinInBrands;
